(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mellooa-anonymous-feedback"] && !Shopify.designMode) return;
  try {
    (() => {
    const registry = window.__mellooaFeedbackRegistry ||= {
      instances: new WeakMap(),
      initialize: null,
      listenersBound: false
    };

    const initialize = root => {
      if (!root || registry.instances.has(root)) return;

      const launcher = root.querySelector('[data-mellooa-feedback-launcher]');
      const modal = root.querySelector('x-modal');
      const form = root.querySelector('form');
      if (!launcher || !modal || !form) return;

      const controller = new AbortController();
      const observers = [];
      const listen = (target, type, handler, options = {}) => {
        target?.addEventListener(type, handler, { ...options, signal: controller.signal });
      };
      const managesStickyCart = root.dataset.mellooaFeedbackManageSticky !== 'false';
      const contextRoot = root.closest('[data-mpdp-root], [data-duo-root]');
      const footer = document.querySelector('.shopify-section--footer');
      const feedbackTrigger = root.closest('.shopify-section--faq') || document.querySelector('.shopify-section--faq') || footer;
      const stickyCart = contextRoot?.querySelector('product-sticky-bar') || document.querySelector('product-sticky-bar');
      const primaryAtc = contextRoot?.querySelector('[data-mpdp-atc], [data-duo-atc]');
      const pageField = root.querySelector('[data-mellooa-feedback-page]');
      const editionField = root.querySelector('[data-mellooa-feedback-edition]');
      const colorField = root.querySelector('[data-mellooa-feedback-color]');
      const success = root.querySelector('[data-mellooa-feedback-success]');
      let purchasePassed = false;
      let feedbackReached = false;

      const updateLauncher = () => {
        const modalOpen = modal?.hasAttribute('open') ?? false;
        const stickyVisible = purchasePassed && !feedbackReached;
        const visible = feedbackReached && !modalOpen;

        if (managesStickyCart) stickyCart?.classList.toggle('is-visible', stickyVisible);
        root.classList.toggle('is-visible', visible);
        launcher?.setAttribute('aria-hidden', String(!visible));
        if (launcher) launcher.tabIndex = visible ? 0 : -1;
      };

      const syncContext = () => {
        if (pageField) pageField.value = window.location.href;
        if (editionField) editionField.value = contextRoot?.querySelector('[data-mpdp-edition]:checked, [data-duo-edition]:checked')?.value || '';
        if (colorField) {
          const duoColors = [...(contextRoot?.querySelectorAll('[data-duo-standard-color]:checked') || [])].map(input => input.value);
          colorField.value = duoColors.length > 0
            ? duoColors.join(' / ')
            : contextRoot?.querySelector('[data-mpdp-color]:checked')?.value || '';
        }
      };

      if (primaryAtc) {
        const purchaseObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          purchasePassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          updateLauncher();
        }, { threshold: 0 });

        purchaseObserver.observe(primaryAtc);
        observers.push(purchaseObserver);
      }

      if (feedbackTrigger) {
        const feedbackObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          feedbackReached = entry.isIntersecting || entry.boundingClientRect.top < window.innerHeight * .88;
          updateLauncher();
        }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });

        feedbackObserver.observe(feedbackTrigger);
        observers.push(feedbackObserver);
      }

      if (managesStickyCart && stickyCart) {
        const stickyObserver = new MutationObserver(updateLauncher);
        stickyObserver.observe(stickyCart, { attributes: true, attributeFilter: ['class'] });
        observers.push(stickyObserver);
      }

      listen(modal, 'dialog:after-show', updateLauncher);
      listen(modal, 'dialog:after-hide', updateLauncher);
      listen(form, 'submit', syncContext);
      listen(launcher, 'click', event => {
        event.preventDefault();
        event.stopPropagation();
        syncContext();
        modal?.setAttribute('open', '');
      });

      syncContext();
      if (primaryAtc) purchasePassed = primaryAtc.getBoundingClientRect().bottom < 0;
      if (feedbackTrigger) feedbackReached = feedbackTrigger.getBoundingClientRect().top < window.innerHeight * .88;
      updateLauncher();

      const cleanup = () => {
        controller.abort();
        observers.forEach(observer => observer.disconnect());
        registry.instances.delete(root);
        delete root.dataset.mellooaFeedbackReady;
      };
      registry.instances.set(root, cleanup);
      root.dataset.mellooaFeedbackReady = 'true';

      if (success && modal) {
        customElements.whenDefined('x-modal').then(() => {
          if (root.isConnected && registry.instances.has(root)) modal.show(false);
        });
      }
    };

    registry.initialize = initialize;
    document.querySelectorAll('[data-mellooa-feedback]').forEach(initialize);

    if (!registry.listenersBound) {
      registry.listenersBound = true;
      document.addEventListener('shopify:section:load', event => {
        event.target.querySelectorAll('[data-mellooa-feedback]').forEach(root => registry.initialize?.(root));
      });
      document.addEventListener('shopify:section:unload', event => {
        event.target.querySelectorAll('[data-mellooa-feedback]').forEach(root => registry.instances.get(root)?.());
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
